import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/nasta-logo.svg'
import _imports_1 from '../assets/ppp-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-3228dcda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo main-logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createTextVNode(" NASTA - ustanova za zdravstvenu njegu "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", { href: "https://maps.app.goo.gl/2q9exnnDoNcdopXV8" }, "Ivana Gundulića 5, 31000 Osijek"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" OIB: 42422517922 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" IBAN: HR4723400091111234002 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Mail: "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:nasta2023pp@gmail.com" }, "nasta2023pp@gmail.com"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Tel: "),
  /*#__PURE__*/_createElementVNode("a", { href: "tel:+38595123322" }, "095 12 33 22")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo ppp-logo",
  src: _imports_1
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createTextVNode(" Tečaj prve pomoći traje 3 dana "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Cijena predavanja je 60 eura "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Uplate na račun PBZ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" IBAN: HR4723400091111234002 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Na predavanje ponijeti knjižicu kandidata. ")
], -1))

import NastaPill from "@/components/NastaPill.vue";
import NastaPills from "@/components/NastaPills.vue";
import SignUp from "@/components/SignUp.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NastaPills, null, {
      default: _withCtx(() => [
        _createVNode(NastaPill, { kind: "wide" }, {
          "additional-content": _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(NastaPill, { kind: "medium" }, {
          "additional-content": _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(SignUp)
      ]),
      _: 1
    })
  ]))
}
}

})